import styled from 'styled-components';

const MessageErrorContainer = styled.div`
    margin: 10rem;
`;

export default MessageErrorContainer;
